var config = require('../../config').config;

function init() {
    var selectElement = document.querySelector('[data-switchOff-modal]')
    if (selectElement) {
        selectElement.addEventListener('change',showCorrectModal)
    }
}
function showCorrectModal(e) {
    var modalURL = '';
    var testName = '';
    e.stopImmediatePropagation();
    if(e.target.dataset && e.target.dataset.switchoffTest){
        testName = e.target.dataset.switchoffTest;
    };
    switch (e.target.options[e.target.selectedIndex].value) {
        case '1':
            if(testName == 'stayAndSave'){
                modalURL = '/'+config.translationPath+'/widget/memberHasCouponStayAndSave'
            }else {
                modalURL = '/'+config.translationPath+'/accountmanagement/showSwitchOffIssueModal?modaltype=1'
            }
            break;
        case '2':
            if (testName == 'stayAndSave') {
                modalURL = '/' + config.translationPath + '/widget/memberHasCouponStayAndSave'
            } else {
                modalURL = '/' + config.translationPath + '/accountmanagement/showSwitchOffIssueModal?modaltype=2'
            }
            break;
        case '3':
            if (e.target.dataset && e.target.dataset.visaService) {
                // user has found someone
                modalURL = '/' + config.translationPath + '/widget/visaServicesModal'
            } else {
                modalURL = ''
            }
            break;
        case '4':
            if (testName == 'stayAndSave') {
                modalURL = '/' + config.translationPath + '/widget/memberHasCouponStayAndSave'
            } else {
                modalURL = '/' + config.translationPath + '/accountmanagement/showSwitchOffIssueModal?modaltype=4'
            }
            break;
        case '5':
            if (testName == 'stayAndSave') {
                modalURL = '/' + config.translationPath + '/widget/memberHasCouponStayAndSave'
            } else {
                modalURL = '/' + config.translationPath + '/accountmanagement/showSwitchOffIssueModal?modaltype=5'
            }
            break;
    }
    if (modalURL != '') {
        var ev = new Event('cm-modal-load', { bubbles: true })
            ev.cmModalUrl = modalURL
            document.dispatchEvent(ev)
    }
}

document.addEventListener('DOMContentLoaded', init)